import { IconButton } from '@mui/material'
import Box from '@mui/material/Box'
import { CSSProperties, useMemo } from 'react'

import { colors, Icons } from 'variables'

interface Props {
  value: boolean | null
  onChange: (value: boolean) => void
}

/**
 * oxの回答フォーム(1行分)
 * oxはラジオ形式でスイッチする
 */
export default function AvailabilityFormComponent(props: Props) {
  const isActive = useMemo(() => {
    // value === null の場合は未選択 両方false
    return {
      ok: props.value === true,
      bad: props.value === false,
    }
  }, [props.value])

  return (
    <Box style={formStyle}>
      <IconButton
        disableRipple={true}
        style={isActive.ok ? activeStyle : inactiveStyle}
        onClick={() => props.onChange(true)}
      >
        <Icons.answerOk fontSize="large" />
      </IconButton>
      <IconButton
        disableRipple={true}
        style={isActive.bad ? activeStyle : inactiveStyle}
        onClick={() => props.onChange(false)}
      >
        <Icons.answerNg fontSize="large" />
      </IconButton>
    </Box>
  )
}

const formStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-evenly',
}

const answerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 45,
  height: 45,
  borderRadius: '8px',
  border: '1px solid #d9d9d9',
  color: '#b4bebe',
  cursor: 'pointer',
}

const activeStyle: CSSProperties = {
  ...answerStyle,
  color: 'white',
  backgroundColor: colors.PRIMARY_COLOR,
}

const inactiveStyle: CSSProperties = {
  ...answerStyle,
  backgroundColor: 'white',
}
